<script>
import styleTransform from '@shared/utils/styleTransform';
import DynamicComp from './dynamic-comp';


export default {
  name: 'Comp',
  props: {
    comp: {
      type: Object,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  mounted() {

  },
  methods: {

  },
  render() {
    const {  comp, $scopedSlots, isLast } = this;
    const formatStyle = styleTransform.getStyle(comp.style);

    const options = {
      props: {
        comp: {
          ...comp, formatStyle,
        },
        isLast,
      },
      scopedSlots: $scopedSlots,
    };

    return <DynamicComp {...options}/>;
  },
};
</script>

<style lang="scss" scoped>


</style>
